<template>
	<div>
		<section>
			<div class="inner row5">
				<article class="infoInner">
					<div class="joinTitle">
						<h1 class="boardTitle">회원가입</h1>
					</div>
					<section class="joinTabBox">
						<div class="tabs">
							<div class="tabMenu">
								<ul>
									<li
										v-for="(tab, index) in tabs"
										:key="tab"
										v-bind:class="{ active: getCurrentTab === index }"
									>
										<span>
											<h5>{{ tab }}</h5>
										</span>
									</li>
								</ul>
							</div>
							<div class="joinTabContent">
								<div v-show="getCurrentTab == 0">
									<JoinType />
								</div>
								<div v-show="getCurrentTab == 1">
									<AgreeTerm />
									<!-- <component v-bind:is="gotoJoinComplete"></component> -->
								</div>
								<div v-show="getCurrentTab == 2">
									<component v-bind:is="gotoJoinInfoWrite"></component>
								</div>
								<div v-show="getCurrentTab == 3">
									<JoinInfoNetworkingWriteUsr v-if="getType === 'USER'" />
									<JoinInfoNetworkingWriteCorp v-else />

									<!-- <component
                    v-bind:is="gotoJoinNetworkingInfoWrite"
                  ></component> -->
								</div>
								<div v-show="getCurrentTab == 4">
									<component v-bind:is="gotoJoinComplete"></component>
								</div>
							</div>
						</div>
					</section>
				</article>
			</div>
		</section>
	</div>
</template>

<script>
import JoinType from '@/components/join/JoinType'
import AgreeTerm from '@/components/join/AgreeTerm'
import JoinInfoWriteUsr from '@/components/join/JoinInfoWriteUsr'
import JoinInfoWriteKakao from '@/components/join/JoinInfoWriteKakao'
import JoinInfoWriteCorp from '@/components/join/JoinInfoWriteCorp'
import JoinInfoNetworkingWriteCorp from '@/components/join/JoinInfoNetworkingWriteCorp'
import JoinInfoNetworkingWriteUsr from '@/components/join/JoinInfoNetworkingWriteUsr'
import JoinCompleteUsr from '@/components/join/JoinCompleteUsr'
import JoinCompleteCorp from '@/components/join/JoinCompleteCorp'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
	name: 'Join',
	components: {
		JoinType,
		AgreeTerm,
		JoinInfoWriteUsr,
		JoinInfoWriteKakao,
		JoinInfoWriteCorp,
		JoinInfoNetworkingWriteCorp,
		JoinInfoNetworkingWriteUsr,
		JoinCompleteUsr,
		JoinCompleteCorp,
	},
	data() {
		return {
			typeComponent: '',
			tabs: [
				'1. 회원가입 유형',
				'2. 약관동의',
				'3. 기본 정보 입력',
				'4. 네트워킹 정보 입력',
				'5. 가입완료',
			],
		}
	},
	computed: {
		...mapGetters('join', ['getCurrentTab', 'getType']),

		gotoJoinInfoWrite() {
			const type = this.getType

			if (type === 'USER') {
				return 'JoinInfoWriteUsr'
			} else if (type === 'KAKAO') {
				return 'JoinInfoWriteKakao'
			} else if (type === 'CORP') {
				return 'JoinInfoWriteCorp'
			} else {
				return ''
			}
		},
		gotoJoinNetworkingInfoWrite() {
			const type = this.getType

			if (type === 'USER') {
				return 'JoinInfoNetWorkingWriteUsr'
			} else if (type === 'CORP') {
				return 'JoinInfoNetworkingWriteCorp'
			} else {
				return ''
			}
		},
		gotoJoinComplete() {
			const type = this.getType

			if (type === 'USER' || type === 'KAKAO') {
				return 'JoinCompleteUsr'
			} else if (type === 'CORP') {
				return 'JoinCompleteCorp'
			} else {
				return ''
			}
		},
	},
	methods: {
		...mapMutations('join', ['setKakaoId', 'setCurrentTab', 'setType']),
		...mapActions('join', ['requestKakaoInfo']),
	},
	mounted() {
		var kakaoCode = this.$route.query.code
		if (kakaoCode != null && kakaoCode != '') {
			this.requestKakaoInfo(kakaoCode)
				.then((result) => {
					if (result.status === 200 && result.data != null) {
						this.setKakaoId(result.data.id)
						this.setType('KAKAO')
						this.setCurrentTab(1)
					} else {
						this.$alert('알림', '카카오톡 정보를 가져올 수 없습니다.')
					}
				})
				.catch(() => {
					this.$alert('알림', '카카오톡 정보를 가져올 수 없습니다.')
				})
		} else {
			this.setCurrentTab(0)
		}
	},
}
</script>

<style scoped>
.infoInner > .infoTitle {
	padding: 0 100px;
}

.infoInner > .infoTitle > h1 {
	color: #9e1915;
}

.infoInner > .joinTitle {
	display: flex;
	justify-content: center;
}

.joinTabBox .tabMenu {
	padding: 20px 10px;
}

.tabMenu {
	margin: 0 0 20px 0;
}

.tabMenu > ul {
	display: flex;
	justify-content: space-between;
}

.tabMenu > ul li {
	font-weight: 500;
	font-size: 20px;
	line-height: 29px;
	color: #ddd;
	padding: 8px 16px;
}

.tabMenu > ul li span h5 {
	color: #636363;
}

.tabMenu > ul li.active {
	background: #e4e7f1;
	border-radius: 30px;
}

.tabMenu > ul li.active span h5 {
	color: #26336a;
}

@media screen and (max-width: 560px) {
	.joinTabBox .tabMenu {
		padding: 30px 0;
		text-align: right;
		margin: 0 0 20px 0;
		border-bottom: 1px solid #d7d8df;
	}

	.tabMenu > ul {
		justify-content: flex-end;
	}

	.tabMenu > ul li {
		display: none;
	}

	.tabMenu > ul li.active {
		display: inline-block;
	}
}
</style>
